import { render } from "./IconLink.vue?vue&type=template&id=db5a6c9c&scoped=true"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"

import "./IconLink.vue?vue&type=style&index=0&id=db5a6c9c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db5a6c9c"]])

export default __exports__